/* eslint-disable no-new */
const shouldUseIntlNumberFormatPolyfill = () => {
  try {
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      currencyDisplay: 'narrowSymbol'
    });
  } catch (error) {
    if (error.toString().includes('currencyDisplay')) {
      return true;
    }

    throw error;
  }

  return false;
};

const createIntlNumberFormatConstructor = OriginalConstructor => {
  return class IntlNumberFormatConstructor {
    constructor(locale, options) {
      const safeOptions = { ...options };

      if (options.currencyDisplay && options.currencyDisplay === 'narrowSymbol') {
        safeOptions.currencyDisplay = 'symbol';
      }

      const args = locale ? [locale, safeOptions] : [safeOptions];

      return new OriginalConstructor(...args);
    }
  };
};

if (shouldUseIntlNumberFormatPolyfill()) {
  Intl.NumberFormat = createIntlNumberFormatConstructor(Intl.NumberFormat);
}
